import type { ImageProps } from '~/components/atoms/Image/Image'
import { urlFor } from '~/components/atoms/Image/Image'
import Spacer, { SpacerSizes } from '~/components/atoms/Spacer/Spacer'
import Text, { TextSizes } from '~/components/atoms/Text/Text'
import VideoEmbed from '~/components/atoms/VideoEmbed/VideoEmbed'

export interface FeaturedVideoProps {
  title: string
  videoUrl: string
  image: ImageProps
  watchTime?: string
}

export interface FeaturedVideoSnippetProps {
  video: FeaturedVideoProps
  showTitle?: boolean
}

export default function FeaturedVideoSnippet({
  video,
  showTitle = true,
}: FeaturedVideoSnippetProps) {
  return (
    <>
      <VideoEmbed
        videoType="youtube"
        videoSrc={video.videoUrl}
        customThumbnail={urlFor(video.image.asset, 600)}
        hideViewOnLink
        watchTime={video.watchTime}
      />
      {showTitle && (
        <>
          <Spacer size={SpacerSizes.sm} />
          <Text size={TextSizes.primaryTitleSml}>{video.title}</Text>
        </>
      )}
    </>
  )
}
